import {
  acceptPartnerFailure,
  acceptPartnerRequest,
  acceptPartnerSuccess,
  getPartnerApprovalFailure,
  getPartnerApprovalRequest,
  getPartnerApprovalSuccess,
  rejectPartnerFailure,
  rejectPartnerRequest,
  rejectPartnerSuccess,
  removePartnerFailure,
  removePartnerRequest,
  removePartnerSuccess,
} from "./partnerApprovalSlice";
import { call, put, takeLatest } from "redux-saga/effects";
import { handleErrorSaga } from "../../utils/helper";
import {
  acceptPartner,
  getPartnersApproval,
  rejectPartner,
  removePartner,
} from "./partnerApprovalApi";

let payloadPartnerApproval;

export function* handleGetPartnerWaiting({ payload }) {
  payloadPartnerApproval = { ...payload };
  try {
    const res = yield call(getPartnersApproval, payload);
    yield put(getPartnerApprovalSuccess(res.data));
  } catch (error) {
    yield put(getPartnerApprovalFailure());
    yield handleErrorSaga(error);
  }
}

function* handleAcceptPartner({ payload }) {
  try {
    yield call(acceptPartner, payload._id);
    yield put(acceptPartnerSuccess());
    yield put(getPartnerApprovalRequest(payloadPartnerApproval));
  } catch (error) {
    yield put(acceptPartnerFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRejectPartner({ payload }) {
  try {
    yield call(rejectPartner, payload);
    yield put(rejectPartnerSuccess());
    yield put(getPartnerApprovalRequest(payloadPartnerApproval));
  } catch (error) {
    yield put(rejectPartnerFailure());
    yield handleErrorSaga(error);
  }
}

function* handleRemovePartner({ payload }) {
  try {
    yield call(removePartner, payload._id);
    yield put(removePartnerSuccess());
    yield put(getPartnerApprovalRequest(payloadPartnerApproval));
  } catch (error) {
    yield put(removePartnerFailure());
    yield handleErrorSaga(error);
  }
}

export default function* partnerTrackingSaga() {
  yield takeLatest(getPartnerApprovalRequest.type, handleGetPartnerWaiting);
  yield takeLatest(acceptPartnerRequest.type, handleAcceptPartner);
  yield takeLatest(rejectPartnerRequest.type, handleRejectPartner);
  yield takeLatest(removePartnerRequest.type, handleRemovePartner);
}
